// eslint-disable-next-line no-unused-vars
import { Button, CircularProgress, Stack, TextField } from "@mui/material";
import { Box } from "@mui/system";
import axios from "axios";
import { useSnackbar } from "notistack";
import React, { useState } from "react";
// eslint-disable-next-line no-unused-vars
import { flattenDiagnosticMessageText } from "typescript";
import { config } from "../App";
import Footer from "./Footer";
import Header from "./Header";
import "./Register.css";
import { useEffect } from "react";
import {Link} from "react-router-dom";
import {useHistory} from "react-router-dom";

const Register = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [formData, setFormData] = useState({
    username: "",
    password: "",
    confirmPassword: "",
  });

  const history = useHistory();


  const [loading, setLoading] = useState(false);

  const _handleCapture = (event, key) => {
    let value = event.target.value;
    let newFormFields = { ...formData };
    newFormFields[key] = value;
    setFormData(newFormFields);
  };

  // TODO: CRIO_TASK_MODULE_REGISTER - Implement the register function
  /**
   * Definition for register handler
   * - Function to be called when the user clicks on the register button or submits the register form
   *
   * @param {{ username: string, password: string, confirmPassword: string }} formData
   *  Object with values of username, password and confirm password user entered to register
   *
   * API endpoint - "POST /auth/register"
   *
   * Example for successful response from backend for the API call:
   * HTTP 201
   * {
   *      "success": true,
   * }
   *
   * Example for failed response from backend for the API call:
   * HTTP 400
   * {
   *      "success": false,
   *      "message": "Username is already taken"
   * }
   */

  const validateInput = async (data) => {
    let isFormValid = true;
    return new Promise((resolve, reject) => {
      if (data.username === "") {
        enqueueSnackbar("Username is a required field", { variant: "warning" });
        isFormValid = false;
      } else if (data.username.length < 6) {
        enqueueSnackbar("Username must be atleast 6 characters", {
          variant: "warning",
        });
        isFormValid = false;
      }

      if (data.password === "") {
        enqueueSnackbar("Password is a required field", { variant: "warning" });
        isFormValid = false;
      } else if (data.password.length < 6) {
        enqueueSnackbar("Password must be atleast 6 characters", {
          variant: "warning",
        });
        isFormValid = false;
      }

      if (data.password !== data.confirmPassword) {
        enqueueSnackbar("Passwords do not match", { variant: "warning" });
        isFormValid = false;
      }

      resolve(isFormValid);
    });
  };

  const register = async (formData) => {
    try {
      setLoading(true);
      let isFormValid = await validateInput(formData);
      
      if (!isFormValid) {
        setLoading(false)
        return;
      }
      
      let postUrl = `${config.endpoint}/auth/register`;
      let postPayload = {
        username: formData.username,
        password: formData.password,
      };
      let response = await axios.post(postUrl, postPayload);
      if (response?.status === 201) {
      history.push('/login')
      enqueueSnackbar("Registered successfully.", { variant: "success" });
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      if (error.response?.status === 400) {
        enqueueSnackbar(error.response?.data?.message, { variant: "error" });
      } else {
        enqueueSnackbar(
          "Something went wrong. Check that the backend is running, reachable and returns valid JSON.",
          { variant: "error" }
        );
      }
    }
  };

  // TODO: CRIO_TASK_MODULE_REGISTER - Implement user input validation logic
  /**
   * Validate the input values so that any bad or illegal values are not passed to the backend.
   *
   * @param {{ username: string, password: string, confirmPassword: string }} data
   *  Object with values of username, password and confirm password user entered to register
   *
   * @returns {boolean}
   *    Whether validation has passed or not
   *
   * Return false if any validation condition fails, otherwise return true.
   * (NOTE: The error messages to be shown for each of these cases, are given with them)
   * -    Check that username field is not an empty value - "Username is a required field"
   * -    Check that username field is not less than 6 characters in length - "Username must be at least 6 characters"
   * -    Check that password field is not an empty value - "Password is a required field"
   * -    Check that password field is not less than 6 characters in length - "Password must be at least 6 characters"
   * -    Check that confirmPassword field has the same value as password field - Passwords do not match
   */

  useEffect(() => {
    document.title = "Register";
  }, []);

  const { username, password, confirmPassword } = formData;
  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
      minHeight="100vh"
    >
      <Header hasHiddenAuthButtons />
      
      <Box className="content">
        <Stack spacing={2} className="form">
          <h2 className="title">Register</h2>
          <TextField
            id="username"
            label="Username"
            variant="outlined"
            title="Username"
            name="username"
            placeholder="Enter Username"
            fullWidth
            value={username}
            onChange={(e) => _handleCapture(e, "username")}
          />
          <TextField
            id="password"
            variant="outlined"
            label="Password"
            name="password"
            type="password"
            helperText="Password must be atleast 6 characters length"
            fullWidth
            placeholder="Enter a password with minimum 6 characters"
            value={password}
            onChange={(e) => _handleCapture(e, "password")}
          />
          <TextField
            id="confirmPassword"
            variant="outlined"
            label="Confirm Password"
            name="confirmPassword"
            type="password"
            fullWidth
            value={confirmPassword}
            onChange={(e) => _handleCapture(e, "confirmPassword")}
          />

          {loading ? (
            <div id="circular_div" >
              <CircularProgress size="25px" />
            </div>
           
          ) : (
            <Button
              // className="button"
              variant="contained"
              onClick={() => register(formData)}
            >
              Register Now
            </Button>
          )}

          <p className="secondary-action">
            Already have an account?
            <Link to = "/login" className="link">
              Login here
            </Link>
          </p>
        </Stack>
      </Box>
      <Footer />
    </Box>
  );
};

export default Register;
